/**
 * Converts a string value to a boolean.
 * @param value - The string value to convert.
 * @param options - Optional configuration options.
 * @param options.strict - If set to true, strict comparison is performed. Default is true.
 * @returns The boolean representation of the string value.
 */
export function stringToBoolean(value: string | undefined, { strict = true }: { strict?: boolean } = {}): boolean {
  if (value === undefined) {
    return false;
  }

  const lowerCasedValue = value.toLowerCase();

  if (strict) {
    return (
      lowerCasedValue !== '' &&
      lowerCasedValue !== 'false' &&
      lowerCasedValue !== '0' &&
      (lowerCasedValue === 'true' || lowerCasedValue === '1')
    );
  }

  return lowerCasedValue !== 'false' && lowerCasedValue !== '0';
}
